import { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from '@mui/material';

import { useNetworkContext } from './network-context-provider';

export const OfflineGuard = () => {
  const { networkStatus, isNotReady } = useNetworkContext();

  const [open, setOpen] = useState(false);
  const [hasTriggered, setHasTriggered] = useState(false);

  // 🚨 Trigger ONLY when first entering offline + not-ready
  useEffect(() => {
    if (!networkStatus && isNotReady && !hasTriggered) {
      setOpen(true);
      setHasTriggered(true);
    }
  }, [networkStatus, isNotReady, hasTriggered]);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (!isNotReady) {
      setHasTriggered(false);
    }
  }, [isNotReady]);

  return (
    <Dialog open={open} fullWidth maxWidth="xs" disableEscapeKeyDown>
      <DialogTitle>Offline Setup Required</DialogTitle>

      <DialogContent>
        <Typography sx={{ mb: 2 }}>
          This app isn’t ready for offline use yet.
        </Typography>

        {!networkStatus ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <CircularProgress size={18} />
            <Typography variant="body2" sx={{ opacity: 0.7 }}>
              Waiting for internet connection…
            </Typography>
          </div>
        ) : (
          <Typography variant="body2" sx={{ opacity: 0.7 }}>
            You’re back online. Please reload the app to enable offline usage.
          </Typography>
        )}
      </DialogContent>

      <DialogActions>
        {networkStatus ? (
          <Button
            variant="contained"
            onClick={() => {
              window.location.reload(); // or updateApp()
            }}
          >
            Reload App
          </Button>
        ) : (
          <Button onClick={handleClose}>Dismiss</Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
